import {ModuleState} from '@gongxigames/framework/slot/fragments/module/ModuleState';
import {GenericPopupEvents} from '@gongxigames/framework/slot/modules/genericPopup/GenericPopupEvents';
import {FreeSpinsModule} from '@gongxigames/framework/slot/modules/freespins/FreeSpinsModule';
import {UIDisableReason} from '@gongxigames/framework/slot/modules/keypad/UIDisableReason';
import {GenericPopupType} from '@gongxigames/framework/slot/modules/genericPopup/GenericPopupType';
import {GlobalEventsMapForBackwardCompatibility} from '@gongxigames/framework/slot/events';

export class FreeSpinsRetriggerState extends ModuleState<null, FreeSpinsModule, GlobalEventsMapForBackwardCompatibility> {
    public onEnterState(): void {
        const type = GenericPopupType.FREESPIN_RETRIGGER;

        this.emit(GenericPopupEvents.SHOW_POPUP, type, this.module.getValueByType(type));
    }

    public onLeaveState(): void {
    }

    protected setupEvents(): void {
        this.setEventHandler(GenericPopupEvents.FADE_OUT_STARTED, this.onPopupFadeOut.bind(this));
    }

    protected onPopupFadeOut(): void {
        this.emit('General.UI.ENABLE', UIDisableReason.TRIGGERING_FEATURE);
        this.module.gotoState(FreeSpinsModule.IN_PROGRESS_STATE);
    }
}
